// 环境配置文件
// 根据不同的环境提供不同的配置

// 开发环境配置
const devConfig = {
  // API基础URL（本地构建可通过 DEV_API_BASE_URL 覆盖）
  apiBaseUrl: process.env.DEV_API_BASE_URL || 'http://127.0.0.1:8888',

  // C端（AIPR frontend）入口URL，用于拼接店铺二维码内容（本地构建可通过 DEV_FRONTEND_BASE_URL 覆盖）
  frontendBaseUrl: process.env.DEV_FRONTEND_BASE_URL || 'http://127.0.0.1:8080',

  // SSO配置
  sso: {
    clientId: '763ae02740294d36868c9832aece3ec0',
    authUrl: 'https://federation-qa.corpnet4.com/as/authorization.oauth2',
    redirectUri: 'http://127.0.0.1:8888/'  // 开发环境重定向URI
  }
};

// UAT环境配置
const uatConfig = {
  // API基础URL
  apiBaseUrl: 'https://aipackage-backend.corpnet5.com',

  // C端入口URL（店铺二维码指向的地址）
  frontendBaseUrl: 'https://aipackage.corpnet5.com',

  // SSO配置（已切换到 Azure AD：sp-ch-AiPackageReaderSso-dev）
  sso: {
    clientId: '3abb5a88-0bb4-4fae-ab23-2ed30f922afb',
    authUrl: 'https://login.microsoftonline.com/d1e23d19-ded6-4d66-850c-0d4f35bf2edc/oauth2/v2.0/authorize',
    scope: 'openid 3abb5a88-0bb4-4fae-ab23-2ed30f922afb/user_impersonation',
    redirectUri: 'https://aipackage-backend.corpnet5.com/'  // UAT环境重定向URI，须与Azure应用注册登记的完全一致
  }
};

// 生产环境配置
const prodConfig = {
  // API基础URL
  apiBaseUrl: 'https://aipackage-backend.haleon.net.cn',

  // C端入口URL（店铺二维码指向的地址）
  frontendBaseUrl: 'https://aipackage.haleon.net.cn',

  // SSO配置（已切换到 Azure AD：sp-ch-AiPackageReaderSso-prod）
  sso: {
    clientId: '8a2ef913-0514-4456-a374-7817fef87716',
    authUrl: 'https://login.microsoftonline.com/d1e23d19-ded6-4d66-850c-0d4f35bf2edc/oauth2/v2.0/authorize',
    scope: 'openid 8a2ef913-0514-4456-a374-7817fef87716/user_impersonation',
    redirectUri: 'https://aipackage-backend.haleon.net.cn/'  // 生产环境重定向URI，须与Azure应用注册登记的完全一致
  }
};

// 判断当前环境
let currentConfig;

// 优先使用构建时指定的环境变量
const buildEnv = process.env.BUILD_ENV;

if (buildEnv) {
  // 根据构建时的环境变量选择配置
  console.log('使用构建时指定的环境:', buildEnv);

  if (buildEnv === 'development') {
    currentConfig = devConfig;
    console.log('当前环境: 开发');
  } else if (buildEnv === 'uat') {
    currentConfig = uatConfig;
    console.log('当前环境: UAT');
  } else if (buildEnv === 'production') {
    currentConfig = prodConfig;
    console.log('当前环境: 生产');
  } else {
    // 默认使用开发环境
    currentConfig = devConfig;
    console.log('未知环境类型，使用开发环境配置');
  }
} else {
  // 如果没有指定构建环境，则根据NODE_ENV判断
  if (process.env.NODE_ENV === 'production') {
    // 检查是否是UAT环境（可以通过自定义环境变量或其他方式判断）
    // 这里使用window.location.hostname作为判断依据
    try {
      const hostname = window.location.hostname;
      if (hostname.includes('corpnet5.com')) {
        currentConfig = uatConfig;
        console.log('当前环境: UAT');
      } else {
        currentConfig = prodConfig;
        console.log('当前环境: 生产');
      }
    } catch (e) {
      // 如果无法获取hostname（例如在服务器端渲染时），默认使用生产配置
      currentConfig = prodConfig;
      console.log('无法获取hostname，默认使用生产环境');
    }
  } else {
    // 开发环境
    currentConfig = devConfig;
    console.log('当前环境: 开发');
  }
}

// 导出当前环境的配置
export default currentConfig;



// WEBPACK FOOTER //
// ./src/utils/config.js